import { render, staticRenderFns } from "./ConsultaMateriais.vue?vue&type=template&id=3e15cb0d&"
import script from "./ConsultaMateriais.vue?vue&type=script&lang=js&"
export * from "./ConsultaMateriais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports